export default __webpack_public_path__ + "static/media/AppStore.a302c5e4.png";